import React, { useState } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: 'longevity',
    message: '',
    subscribe: false
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setFormData({
        name: '',
        email: '',
        phone: '',
        service: 'longevity',
        message: '',
        subscribe: false
      });
    }, 3000);
  };

  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="bg-gradient-to-b from-primary to-primary-container py-20 px-margin-mobile">
        <div className="max-w-container-max mx-auto text-center">
          <h1 className="text-display-lg text-on-primary mb-6">Get In Touch</h1>
          <p className="text-headline-md text-on-primary/90 max-w-2xl mx-auto">
            Ready to optimize your longevity? Schedule a consultation with our experts.
          </p>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-section-gap px-margin-mobile bg-background">
        <div className="max-w-container-max mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            {/* Contact Info */}
            <div>
              <div className="mb-12">
                <h3 className="text-headline-md text-on-background mb-4 flex items-center gap-3">
                  <span className="material-symbols-outlined text-accent">location_on</span>
                  Address
                </h3>
                <p className="text-body-md text-on-background/80">
                  Wellis International<br />
                  123 Wellness Avenue<br />
                  San Francisco, CA 94105<br />
                  United States
                </p>
              </div>

              <div>
                <h3 className="text-headline-md text-on-background mb-4 flex items-center gap-3">
                  <span className="material-symbols-outlined text-accent">mail</span>
                  Email
                </h3>
                <p className="text-body-md text-on-background/80">
                  <a href="mailto:info@wellis.club" className="hover:text-accent transition-colors">
                    info@wellis.club
                  </a>
                </p>
              </div>

              <div className="mt-12 pt-12 border-t border-outline-variant/20">
                <h3 className="text-headline-md text-on-background mb-4">Hours</h3>
                <p className="text-body-md text-on-background/80">
                  Monday - Friday: 9am - 6pm PST<br />
                  Saturday: 10am - 4pm PST<br />
                  Sunday: Closed
                </p>
              </div>
            </div>

            {/* Contact Form */}
            <div className="lg:col-span-2">
              <form onSubmit={handleSubmit} className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-label-md text-on-background font-semibold mb-2">
                      Name *
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 bg-primary-container/30 border border-outline-variant rounded-lg text-on-background placeholder-on-background/40 focus:outline-none focus:ring-2 focus:ring-accent"
                      placeholder="Your name"
                    />
                  </div>

                  <div>
                    <label className="block text-label-md text-on-background font-semibold mb-2">
                      Email *
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 bg-primary-container/30 border border-outline-variant rounded-lg text-on-background placeholder-on-background/40 focus:outline-none focus:ring-2 focus:ring-accent"
                      placeholder="your@email.com"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-label-md text-on-background font-semibold mb-2">
                      Phone
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="w-full px-4 py-3 bg-primary-container/30 border border-outline-variant rounded-lg text-on-background placeholder-on-background/40 focus:outline-none focus:ring-2 focus:ring-accent"
                      placeholder="(555) 123-4567"
                    />
                  </div>

                  <div>
                    <label className="block text-label-md text-on-background font-semibold mb-2">
                      Interested Service
                    </label>
                    <select
                      name="service"
                      value={formData.service}
                      onChange={handleChange}
                      className="w-full px-4 py-3 bg-primary-container/30 border border-outline-variant rounded-lg text-on-background focus:outline-none focus:ring-2 focus:ring-accent"
                    >
                      <option value="longevity">Longevity Program</option>
                      <option value="wellness">Wellness Assessment</option>
                      <option value="personalized">Personalized Plans</option>
                      <option value="monitoring">Continuous Monitoring</option>
                      <option value="concierge">Concierge Membership</option>
                      <option value="retreat">Wellness Retreat</option>
                      <option value="genetic">Genetic Sequencing</option>
                      <option value="nutrition">Nutrition Coaching</option>
                    </select>
                  </div>
                </div>

                <div>
                  <label className="block text-label-md text-on-background font-semibold mb-2">
                    Message *
                  </label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows={6}
                    className="w-full px-4 py-3 bg-primary-container/30 border border-outline-variant rounded-lg text-on-background placeholder-on-background/40 focus:outline-none focus:ring-2 focus:ring-accent resize-none"
                    placeholder="Tell us about your longevity goals and questions..."
                  />
                </div>

                <div className="flex items-center gap-3">
                  <input
                    type="checkbox"
                    id="subscribe"
                    name="subscribe"
                    checked={formData.subscribe}
                    onChange={handleChange}
                    className="w-5 h-5 accent-accent"
                  />
                  <label htmlFor="subscribe" className="text-body-md text-on-background/80">
                    Subscribe to our longevity insights and wellness tips
                  </label>
                </div>

                {submitted && (
                  <div className="p-4 bg-accent/20 border border-accent/50 rounded-lg text-center">
                    <p className="text-accent font-semibold">
                      Thank you! We'll be in touch soon.
                    </p>
                  </div>
                )}

                <button
                  type="submit"
                  className="w-full px-6 py-4 bg-accent text-on-accent rounded-full font-bold text-label-lg uppercase tracking-widest hover:opacity-90 transition-opacity"
                >
                  Send Message
                </button>

                <p className="text-body-sm text-on-background/60 text-center">
                  * Required fields
                </p>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-section-gap px-margin-mobile bg-primary-container">
        <div className="max-w-container-max mx-auto">
          <h2 className="text-display-md text-on-primary-container mb-12 text-center">
            Frequently Asked Questions
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div>
              <h3 className="text-headline-md text-on-primary-container mb-3">
                What's the first step?
              </h3>
              <p className="text-body-md text-on-primary-container/80">
                Schedule a free 20-minute consultation call with one of our longevity specialists. We'll discuss your goals and recommend the best program for you.
              </p>
            </div>

            <div>
              <h3 className="text-headline-md text-on-primary-container mb-3">
                How much does it cost?
              </h3>
              <p className="text-body-md text-on-primary-container/80">
                Programs range from $1,200 for wellness assessments to $10,000+ annually for concierge memberships. We offer flexible payment plans.
              </p>
            </div>

            <div>
              <h3 className="text-headline-md text-on-primary-container mb-3">
                How long does the program take?
              </h3>
              <p className="text-body-md text-on-primary-container/80">
                Initial programs range from 4 weeks to 6 months. Many clients continue with ongoing monitoring and quarterly check-ins.
              </p>
            </div>

            <div>
              <h3 className="text-headline-md text-on-primary-container mb-3">
                Can I do this remotely?
              </h3>
              <p className="text-body-md text-on-primary-container/80">
                Yes! Most consultations and coaching are via video call. We can arrange at-home testing kits or in-person visits as needed.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-primary text-on-primary py-section-gap px-margin-mobile">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-display-md mb-6">Ready to Start Your Journey?</h2>
          <p className="text-headline-md mb-12 opacity-90">
            Our team is ready to help you optimize your longevity today.
          </p>

          <button
            onClick={() => document.querySelector('input[name="name"]').focus()}
            className="inline-block px-12 py-4 bg-accent text-on-accent rounded-full font-bold text-label-lg uppercase tracking-widest hover:opacity-90 transition-opacity"
          >
            Fill Out Form Above
          </button>
        </div>
      </section>
    </div>
  );
}
